module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 6,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品货号，多个货号间请用','号分隔",
      "clearable": "",
      "size": "mini"
    },
    on: {
      "clear": _vm.sku_bnSearch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sku_bnSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.sku_bn),
      callback: function($$v) {
        _vm.sku_bn = $$v
      },
      expression: "sku_bn"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.sku_bnSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 9,
      "lg": 9
    }
  }, [(_vm.exportLoading == false) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportLoading),
      expression: "exportLoading"
    }],
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]) : _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportLoading),
      expression: "exportLoading"
    }],
    attrs: {
      "size": "mini",
      "type": "primary",
      "element-loading-text": "拼命导出中..."
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表-优选商品’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "报表下载",
      "visible": _vm.downloadView,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.downloadView = $event
      }
    }
  }, [(_vm.downloadUrl) ? [_c('a', {
    attrs: {
      "href": _vm.downloadUrl,
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.downloadName))])] : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.skuListData,
      "height": _vm.wheight - 210
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "label": "全选"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sku_id",
      "label": "商品ID",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cat_id",
      "label": "分类ID",
      "width": "66"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sku_name",
      "label": "商品名称",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sku_bn",
      "label": "商品货号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "240",
            "trigger": "hover"
          }
        }, [_c('img', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "src": scope.row.image_default_id
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('img', {
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.image_default_id
          }
        })])], 1)]
      }
    }], null, false, 139113381)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "销售价",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rate_1",
      "label": "自定义分佣",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_rate_custom == 1) ? _c('el-tag', [_vm._v("否")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("是")])]
      }
    }], null, false, 2080343296)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pcate_name",
      "label": "所属推类",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rate_1",
      "label": "分佣比例",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brokerage",
      "label": "佣金",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "p_order",
      "label": "排序",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_share",
      "label": "推广",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_share == '1') ? _c('el-tag', [_vm._v("是")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("否")])]
      }
    }], null, false, 822103875)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "marketable",
      "label": "状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.marketable == 'true') ? _c('el-tag', [_vm._v("上架")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("下架")])]
      }
    }], null, false, 18455466)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn-gap",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editInfo(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "450",
            "trigger": "hover"
          }
        }, [_c('div', {
          staticClass: "operating-icons"
        }, [_c('el-button', {
          staticClass: "btn-gap",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.deleteSkuAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "iconfont icon-angle-double-right"
        })])], 1)]
      }
    }], null, false, 3669137689)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded tc"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.editInfoDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editInfoDialog = $event
      }
    }
  }, [
    [_c('el-form', [_c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "商品ID"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "商品ID",
        "disabled": ""
      },
      model: {
        value: (_vm.form.sku_id),
        callback: function($$v) {
          _vm.$set(_vm.form, "sku_id", $$v)
        },
        expression: "form.sku_id"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "商品货号"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "商品货号",
        "disabled": ""
      },
      model: {
        value: (_vm.form.sku_bn),
        callback: function($$v) {
          _vm.$set(_vm.form, "sku_bn", $$v)
        },
        expression: "form.sku_bn"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "商品名称"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "商品名称",
        "disabled": ""
      },
      model: {
        value: (_vm.form.sku_name),
        callback: function($$v) {
          _vm.$set(_vm.form, "sku_name", $$v)
        },
        expression: "form.sku_name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "限量团购"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "限量团购",
        "type": "number"
      },
      model: {
        value: (_vm.form.max_sell),
        callback: function($$v) {
          _vm.$set(_vm.form, "max_sell", $$v)
        },
        expression: "form.max_sell"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "分享文案"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "分享文案"
      },
      model: {
        value: (_vm.form.share_con),
        callback: function($$v) {
          _vm.$set(_vm.form, "share_con", $$v)
        },
        expression: "form.share_con"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "优惠券ID"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "优惠券ID",
        "type": "number"
      },
      model: {
        value: (_vm.form.coupon_id),
        callback: function($$v) {
          _vm.$set(_vm.form, "coupon_id", $$v)
        },
        expression: "form.coupon_id"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "设置分佣"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.form.is_rate_custom),
        callback: function($$v) {
          _vm.$set(_vm.form, "is_rate_custom", $$v)
        },
        expression: "form.is_rate_custom"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 0
      }
    }, [_vm._v("自定义分佣比例")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 1
      }
    }, [_vm._v("关联商品推类")])], 1)], 1), _vm._v(" "), (_vm.form.is_rate_custom == 0) ? _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "分佣比例"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "分佣比例",
        "type": "number"
      },
      model: {
        value: (_vm.form.rate_1),
        callback: function($$v) {
          _vm.$set(_vm.form, "rate_1", $$v)
        },
        expression: "form.rate_1"
      }
    })], 1) : (_vm.form.is_rate_custom == 1) ? _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "分佣比例"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择商品推类"
      },
      model: {
        value: (_vm.form.promotecate_id),
        callback: function($$v) {
          _vm.$set(_vm.form, "promotecate_id", $$v)
        },
        expression: "form.promotecate_id"
      }
    }, _vm._l((_vm.promotecate_list), function(item) {
      return _c('el-option', {
        key: item.name,
        attrs: {
          "label": item.pcate_name + ' 类        ' + item.pcate_ratio,
          "value": item.id
        }
      }, [_c('span', {
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(_vm._s(item.pcate_name))]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "right",
          "color": "#8492a6",
          "font-size": "13px"
        }
      }, [_vm._v(_vm._s(item.pcate_ratio))])])
    }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "是否推广"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.form.is_share),
        callback: function($$v) {
          _vm.$set(_vm.form, "is_share", $$v)
        },
        expression: "form.is_share"
      }
    }, [_c('el-radio-button', {
      attrs: {
        "label": '0'
      }
    }, [_vm._v("否")]), _vm._v(" "), _c('el-radio-button', {
      attrs: {
        "label": '1'
      }
    }, [_vm._v("是")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "推广时间"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-date-picker', {
      attrs: {
        "type": "datetimerange",
        "range-separator": "至",
        "start-placeholder": "推广开始时间",
        "end-placeholder": "推广结束时间",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "default-time": ['00:00:00', '23:59:59']
      },
      model: {
        value: (_vm.activity_date),
        callback: function($$v) {
          _vm.activity_date = $$v
        },
        expression: "activity_date"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "排序"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "排序",
        "type": "number"
      },
      model: {
        value: (_vm.form.p_order),
        callback: function($$v) {
          _vm.$set(_vm.form, "p_order", $$v)
        },
        expression: "form.p_order"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "优卡商品折扣"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "优卡商品折扣",
        "type": "number"
      },
      model: {
        value: (_vm.form.proportion),
        callback: function($$v) {
          _vm.$set(_vm.form, "proportion", $$v)
        },
        expression: "form.proportion"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "是否优卡专区"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.form.is_youka),
        callback: function($$v) {
          _vm.$set(_vm.form, "is_youka", $$v)
        },
        expression: "form.is_youka"
      }
    }, [_c('el-radio-button', {
      attrs: {
        "label": '0'
      }
    }, [_vm._v("否")]), _vm._v(" "), _c('el-radio-button', {
      attrs: {
        "label": '1'
      }
    }, [_vm._v("是")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "宽图",
        "prop": "udfimg"
      }
    }, [_c('div', {
      staticClass: "upload-box",
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('udfimg')
        }
      }
    }, [(_vm.form.udfimg) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.form.udfimg
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon"
    })]), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("\n              建议尺寸680*380\n            ")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "图片",
        "prop": "image_default_id"
      }
    }, [_c('div', {
      staticClass: "upload-box",
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('image_default_id')
        }
      }
    }, [(_vm.form.image_default_id) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.form.image_default_id
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon"
    })]), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("\n              建议尺寸600*600\n            ")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "缩略图",
        "prop": "thumbnail_pic"
      }
    }, [_c('div', {
      staticClass: "upload-box",
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('thumbnail_pic')
        }
      }
    }, [(_vm.form.thumbnail_pic) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.form.thumbnail_pic
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon"
    })]), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("\n              建议尺寸300*300\n            ")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "营销图标"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.form.tui_icon),
        callback: function($$v) {
          _vm.$set(_vm.form, "tui_icon", $$v)
        },
        expression: "form.tui_icon"
      }
    }, _vm._l((_vm.iconList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.title,
          "value": item.id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editInfoSubmit()
        }
      }
    }, [_vm._v("确定")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f1e4fe2a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1e4fe2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/sharer/sku/sku_list.vue
// module id = 2977
// module chunks = 0